const Slider = require('../../components/slider');

module.exports = Slider;
